var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"look-more",on:{"click":_vm.lookMore}},[_vm._v("\n  查看更多\n  "),_c('i',{staticClass:"el-icon-arrow-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }